// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__en-NU","label":"ContactForm_label__U4w2H","input":"ContactForm_input__L58E6","button":"ContactForm_button__TnX+A"};